/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does the optimizer suggest a team without the championship leader?`)
};

const es_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué el optimizador sugiere un equipo sin el líder del campeonato?`)
};

const de_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum schlägt der Optimizer ein Team ohne den Meisterschaftsführenden vor?`)
};

const nl_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom stelt de optimizer een team voor zonder de kampioenschapsleider?`)
};

const fr_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi l'optimiseur suggère-t-il une équipe sans le leader du championnat ?`)
};

const it_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché l'ottimizzatore suggerisce una squadra senza il leader del campionato?`)
};

const pt_br2_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que o otimizador sugere uma equipe sem o líder do campeonato?`)
};

const pt_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que razão o otimizador sugere uma equipa sem o líder do campeonato?`)
};

const ja_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜオプティマイザーはチャンピオンシップリーダーを含まないチームを提案するのですか？`)
};

const zh_f1_ax_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么优化器推荐的车队里没有积分榜领跑者？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ax_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ax_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ax_faq4_q", locale)
	if (locale === "en") return en_f1_ax_faq4_q(inputs)
	if (locale === "es") return es_f1_ax_faq4_q(inputs)
	if (locale === "de") return de_f1_ax_faq4_q(inputs)
	if (locale === "nl") return nl_f1_ax_faq4_q(inputs)
	if (locale === "fr") return fr_f1_ax_faq4_q(inputs)
	if (locale === "it") return it_f1_ax_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ax_faq4_q(inputs)
	if (locale === "pt") return pt_f1_ax_faq4_q(inputs)
	if (locale === "ja") return ja_f1_ax_faq4_q(inputs)
	return zh_f1_ax_faq4_q(inputs)
};